var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeA18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 31,
    rx: 5.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81763 24L10.9616 7.2H14.4176L20.5616 24H17.2976L15.9536 20.112H9.40163L8.03363 24H4.81763ZM10.2416 17.712H15.1136L12.6656 10.728L10.2416 17.712ZM23.8232 24V10.704L21.0632 11.352V9L25.1192 7.2H27.0152V24H23.8232ZM36.2006 24.288C35.0486 24.288 34.0086 24.088 33.0806 23.688C32.1526 23.272 31.4086 22.688 30.8486 21.936C30.3046 21.184 30.0326 20.312 30.0326 19.32C30.0326 18.296 30.2966 17.4 30.8246 16.632C31.3686 15.864 32.0806 15.312 32.9606 14.976C32.1926 14.64 31.5846 14.16 31.1366 13.536C30.6886 12.896 30.4646 12.184 30.4646 11.4C30.4646 10.6 30.6806 9.864 31.1126 9.192C31.5446 8.504 32.1846 7.952 33.0326 7.536C33.8966 7.12 34.9526 6.912 36.2006 6.912C37.4486 6.912 38.4966 7.12 39.3446 7.536C40.1926 7.952 40.8326 8.504 41.2646 9.192C41.6966 9.864 41.9126 10.6 41.9126 11.4C41.9126 12.168 41.6806 12.88 41.2166 13.536C40.7686 14.176 40.1686 14.656 39.4166 14.976C40.3126 15.312 41.0246 15.864 41.5526 16.632C42.0806 17.4 42.3446 18.296 42.3446 19.32C42.3446 20.312 42.0726 21.184 41.5286 21.936C40.9846 22.688 40.2406 23.272 39.2966 23.688C38.3686 24.088 37.3366 24.288 36.2006 24.288ZM36.2006 14.064C37.0326 14.064 37.6886 13.848 38.1686 13.416C38.6486 12.984 38.8886 12.432 38.8886 11.76C38.8886 11.024 38.6486 10.448 38.1686 10.032C37.7046 9.616 37.0486 9.408 36.2006 9.408C35.3366 9.408 34.6726 9.616 34.2086 10.032C33.7446 10.448 33.5126 11.024 33.5126 11.76C33.5126 12.448 33.7446 13.008 34.2086 13.44C34.6886 13.856 35.3526 14.064 36.2006 14.064ZM36.2006 21.72C37.2246 21.72 38.0006 21.472 38.5286 20.976C39.0566 20.464 39.3206 19.824 39.3206 19.056C39.3206 18.208 39.0406 17.544 38.4806 17.064C37.9366 16.584 37.1766 16.344 36.2006 16.344C35.2246 16.344 34.4486 16.584 33.8726 17.064C33.3126 17.544 33.0326 18.208 33.0326 19.056C33.0326 19.824 33.2966 20.464 33.8246 20.976C34.3686 21.472 35.1606 21.72 36.2006 21.72Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 31,
    rx: 5.5,
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeA18);
export default __webpack_public_path__ + "static/media/age-a18.7b8ac2ee94151217b48cb81238f99b65.svg";
export { ForwardRef as ReactComponent };